import api from '@/services/utils/apiInstance.ts';
import { downloadBlob, parseFilenameFromContentDisposition } from '@/utils/fileDownloadUtils.ts';

class ClientExportService {
  // Downloads the 4-sheet .xlsx export (client info, client declaration, investor form, LCB-FT)
  // aggregated server-side. The response is the raw file, not JSON — triggers a browser download
  // directly rather than returning data to display.
  async exportClient(userId: number): Promise<void> {
    const response = await api.get(`/user/${userId}/export`, {
      responseType: 'blob'
    });

    // Axios normally lowercases all headers
    const contentDisposition: string | undefined = response.headers['content-disposition'];
    const defaultFilename = `fiche_client_${userId}.xlsx`;

    downloadBlob(response.data, parseFilenameFromContentDisposition(contentDisposition, defaultFilename));
  }
}

export default new ClientExportService();
